module.exports = __webpack_public_path__ + "static/media/close_new.dfbeef6d.svg";